import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as Actions from './actions';

const State = Record({
    loading: false,
    submitting: false,
    hideAsParticipant: null,
});

export default handleActions(
    {
        [Actions.fetch.type]: state =>
            state.merge({
                loading: true,
            }),
        [Actions.fetchSuccess.type]: (state, {payload}) =>
            state.merge({
                loading: false,
                hideAsParticipant: payload.response.hideAsParticipant,
            }),
        [Actions.fetchFailed.type]: state =>
            state.merge({
                loading: false,
            }),
        [Actions.update.type]: state =>
            state.merge({
                submitting: true,
            }),
        [Actions.updateSuccess.type]: (state, {payload}) =>
            state.merge({
                submitting: false,
                hideAsParticipant: payload.response.hideAsParticipant,
            }),
        [Actions.updateFailed.type]: state =>
            state.merge({
                submitting: false,
            }),
    },
    new State(),
);
